import React from 'react';
import { SEMANTIC_HR_CONTACT_HREF, SEMANTIC_HR_RBAC_CROSS_LINK } from '../../../../content/enterpriseMessaging';

const trustPoints = [
  {
    title: 'Role-based access in plain language',
    description:
      'Compensation, PII, EEO, and performance data are separated by domain roles; leaders see what their role permits, not everything in one undifferentiated view.',
  },
  {
    title: 'Transparent answers',
    description:
      'Expandable SQL and query reasoning let analytics and security teams verify how each answer was produced, not a black-box chatbot.',
  },
  {
    title: 'Evaluate without your data',
    description:
      'Explore Semantic HR on a deterministic synthetic global enterprise, realistic workforce scale and history, safe for executive briefings and vendor evaluation.',
  },
];

export default function TrustAndDemo() {
  const rbacLink = SEMANTIC_HR_RBAC_CROSS_LINK;

  return (
    <section className="py-10 md:py-12">
      <div className="container-x">
        <div className="mx-auto max-w-3xl text-center">
          <p className="eyebrow">Trust &amp; Evaluation</p>
          <h2 className="mt-3 text-3xl font-semibold tracking-tight text-ink-900 sm:text-4xl">
            Built for HR Leaders and Their Stakeholders
          </h2>
          <p className="mt-4 text-lg leading-relaxed text-ink-600">
            CHROs need speed. CISOs and legal need governance. Semantic HR is designed for both, and you
            can evaluate it on synthetic data before connecting production HRIS sources.
          </p>
          <p className="mt-4 text-sm leading-relaxed text-ink-500">
            {rbacLink.body}{' '}
            <a href={rbacLink.href} className="font-medium text-brand-600 hover:text-brand-700">
              {rbacLink.linkLabel} →
            </a>
          </p>

          <ul className="mx-auto mt-8 max-w-2xl space-y-4 text-left">
            {trustPoints.map((point, i) => (
              <li
                key={point.title}
                className="flex items-start gap-4 border-b border-ink-100 pb-4 last:border-b-0 last:pb-0"
              >
                <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-brand-50 text-sm font-semibold text-brand-700">
                  {i + 1}
                </span>
                <div>
                  <p className="text-sm font-semibold text-ink-900">{point.title}</p>
                  <p className="mt-1 text-sm leading-relaxed text-ink-600">{point.description}</p>
                </div>
              </li>
            ))}
          </ul>

          <div className="mt-8 flex flex-wrap justify-center gap-3">
            <a href={SEMANTIC_HR_CONTACT_HREF} className="btn-secondary">
              Request demo on synthetic data
            </a>
            <a href="#architecture" className="btn-ghost">
              Security &amp; architecture →
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
